export enum BoardConst {
    TOP = 0,
    TOP_RIGHT = 1,
    RIGHT = 2,
    BOTTOM_RIGHT = 3,
    BOTTOM = 4,
    BOTTOM_LEFT = 5,
    LEFT = 6,
    TOP_LEFT = 7,

    AXIS_VERTICAL = 8,
    AXIS_HORIZONTAL = 9,
    AXIS_SLASH = 10,
    AXIS_BACKSLASH = 11,

    RANK = 12
}

export const BOARD_X = 36;
export const BOARD_Y = 36;
export const BOARD_SIZE = BOARD_X * BOARD_Y;

export const N_PIECES = 804;
export const N_RANKS = 4;

export const GOTE_TERRITORY_Y_MAX = 10;
export const SENTE_TERRITORY_Y_MIN = 25;

export const DIRECTION_KEYS = [
    BoardConst.TOP, BoardConst.TOP_RIGHT, BoardConst.RIGHT, BoardConst.BOTTOM_RIGHT,
    BoardConst.BOTTOM, BoardConst.BOTTOM_LEFT, BoardConst.LEFT, BoardConst.TOP_LEFT
];

export const DIRECTION_VECTORS: Record<BoardConst, [number, number]> = {
    [BoardConst.TOP]: [0, -1],
    [BoardConst.TOP_RIGHT]: [1, -1],
    [BoardConst.RIGHT]: [1, 0],
    [BoardConst.BOTTOM_RIGHT]: [1, 1],
    [BoardConst.BOTTOM]: [0, 1],
    [BoardConst.BOTTOM_LEFT]: [-1, 1],
    [BoardConst.LEFT]: [-1, 0],
    [BoardConst.TOP_LEFT]: [-1, -1],
} as any;

export function get_ray_direction(base_x: number, base_y: number, target_x: number, target_y: number): BoardConst | null {
    const dx = target_x - base_x;
    const dy = target_y - base_y;
    if (dx === 0 && dy === 0) return null;
    if (dx === 0 || dy === 0 || Math.abs(dx) === Math.abs(dy)) {
        const sign = (v: number) => (v > 0 ? 1 : (v < 0 ? -1 : 0));
        const sdx = sign(dx);
        const sdy = sign(dy);
        for (const k of DIRECTION_KEYS) {
            const v = DIRECTION_VECTORS[k];
            if (v[0] === sdx && v[1] === sdy) return k;
        }
    }
    return null;
}

export const DIRECTION_STEPS: Record<BoardConst, number> = {} as any;
for (const k of DIRECTION_KEYS) {
    const [x, y] = DIRECTION_VECTORS[k];
    DIRECTION_STEPS[k] = y * BOARD_X + x;
}

export const DIRECTION_TURN: Record<BoardConst, [BoardConst, BoardConst]> = {
    [BoardConst.TOP]: [BoardConst.LEFT, BoardConst.RIGHT],
    [BoardConst.TOP_RIGHT]: [BoardConst.TOP_LEFT, BoardConst.BOTTOM_RIGHT],
    [BoardConst.RIGHT]: [BoardConst.TOP, BoardConst.BOTTOM],
    [BoardConst.BOTTOM_RIGHT]: [BoardConst.TOP_RIGHT, BoardConst.BOTTOM_LEFT],
    [BoardConst.BOTTOM]: [BoardConst.LEFT, BoardConst.RIGHT],
    [BoardConst.BOTTOM_LEFT]: [BoardConst.TOP_LEFT, BoardConst.BOTTOM_RIGHT],
    [BoardConst.LEFT]: [BoardConst.TOP, BoardConst.BOTTOM],
    [BoardConst.TOP_LEFT]: [BoardConst.TOP_RIGHT, BoardConst.BOTTOM_LEFT],
} as any;

export const TURN_MSB_VECTORS: Record<BoardConst, [number, number]> = {} as any;
for (const k of DIRECTION_KEYS) {
    TURN_MSB_VECTORS[k] = DIRECTION_VECTORS[DIRECTION_TURN[k][1]];
}

export const DIRECTION_FLIP: Record<BoardConst, BoardConst> = {
    [BoardConst.TOP]: BoardConst.BOTTOM,
    [BoardConst.TOP_RIGHT]: BoardConst.BOTTOM_LEFT,
    [BoardConst.RIGHT]: BoardConst.LEFT,
    [BoardConst.BOTTOM_RIGHT]: BoardConst.TOP_LEFT,
    [BoardConst.BOTTOM]: BoardConst.TOP,
    [BoardConst.BOTTOM_LEFT]: BoardConst.TOP_RIGHT,
    [BoardConst.LEFT]: BoardConst.RIGHT,
    [BoardConst.TOP_LEFT]: BoardConst.BOTTOM_RIGHT,
} as any;

export const JSON_DIR_TO_CONST: Record<string, BoardConst> = {
    'top': BoardConst.TOP,
    'topright': BoardConst.TOP_RIGHT,
    'right': BoardConst.RIGHT,
    'bottomright': BoardConst.BOTTOM_RIGHT,
    'bottom': BoardConst.BOTTOM,
    'bottomleft': BoardConst.BOTTOM_LEFT,
    'left': BoardConst.LEFT,
    'topleft': BoardConst.TOP_LEFT,
};

export const MOVE_NORMAL_MAX = 35;
export const MOVE_SKIP3 = 36;
export const MOVE_SNIPER = 37;
export const MOVE_PIERCING_RANK1 = 38;
export const MOVE_PIERCING_RANK2 = 39;
export const MOVE_PIERCING_RANK3 = 40;
